<template>
  <div>
    <v-footer>
      <v-divider />
      <v-col class="text-center" cols="12">
        &copy; {{ new Date().getFullYear() }} — <strong>EMS - Employee Management System</strong> &nbsp;
        <span>Develop By </span>
        <strong><a target="_blank" href="https://datasoft-bd.com">DataSoft</a></strong>
      </v-col>
    </v-footer>
  </div>
</template>

<script>
export default {
  name: 'FooterComponent',

}
</script>